import React, { useState,useEffect } from 'react';
import { Button, Checkbox, InfoBox, Input } from 'components';
import { Modal, Form } from 'antd';
import './basket-summary.less'
import 'components/Modal/modal.less'
import Promo from 'assests/icons/promo.icon';
import classNames from 'classnames';
import { usePackage } from 'context/package.context';
import SalesModal from './parts/sales-modal';
import AgreementModal from './parts/agreement-modal';
import ConfirmModal from './parts/confirm-modal';
import { chargePackage, buyingViaCreditCardChecks, checkCouponCode, createVirtualInvoices, getCreditCardToken, getThreeDSessionId } from 'services/omcc.service';
import { customMessages } from 'utils';
import { useHistory } from 'react-router';
import config from '../../../config';
import formatter from 'string-format';
const BasketSummary = (props) => {

  const {
    selectedPackage,
    ccToken,
    setCCToken,
    setTriggerClick,
    setThreeDSessionId,
    setCallBackUrl,
    discountList,
    setDiscountList
  } = usePackage();
  const history = useHistory();
  const [modalConfirm, setModalConfirm] = useState(false);
  const [modalDiscount, setModalDiscount] = useState(false);
  const [validDiscount, setValidDiscount] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [formDiscount] = Form.useForm();
  const [activeIndex, setActiveIndex] = useState(props.tabIndex);

  const [loadingCCToken, setLoadinCCToken] = useState(false);

  const checkError = fieldName => {
    if (formDiscount.isFieldTouched(fieldName) && formDiscount.getFieldError(fieldName).length === 0) {
      return true;
    }
  }

  const onValuesChange = () => {
    setTimeout(() => {
      let inputs = formDiscount.getFieldsError();

      for (var i = 0; i < inputs.length; i++) {
        let formItemName = inputs[i]['name'][0];

        if (checkError(formItemName)) {
          setValidDiscount(true);
        } else {
          setValidDiscount(false);
          break;
        }
      }
    }, 10)
  }


  const openConfirm = () => {

    let values= props.formRef.current.getFieldsValue();
    if (!selectedPackage?.no)
    {
      Modal.error({
        title: 'Hata',
        content: "Paket Seçiniz",
      });
      return;
    }


    if (!values.informationContract)
    {
      Modal.error({
        title: 'Hata',
        content: "Lütfen Sözleşmeleri Onaylayınız",
      });
      return;
    }
    if(activeIndex == "1"){
      buyingViaCreditCardChecks({
      }).then((result => {
      })).catch((err) => {
        var errorMessage;
        if (err.responseCode == 1103 || err.responseCode == 1104 || err.responseCode == 1105) {
          errorMessage = formatter(customMessages.getMessage(err.responseCode), err.properties.maxUsage)
        } else if (err.responseCode == 893) {
          errorMessage = formatter(customMessages.getMessage(err.responseCode), err.properties.minAllowedContractDates)
        }
        else {
          errorMessage = customMessages.getMessage(err.responseCode)
        }
        Modal.error({
          title: 'Hata',
          content: errorMessage
        });
        return;
      });
    }

    // buyingViaCreditCardChecks async olduğu için sonucunu beklemeden devam edilmez;
    // sadece token alımı ve modal açma işlemi burada yönetilir
    if (activeIndex=="1" && values.paymentMethod==0)
    {
      getCreditCardToken(values).then((result) => {
        setCCToken(result.properties.token);
        setModalConfirm(true);
      }).catch((err) => {
        var errorMessage;
        if (err.responseCode == 1103 || err.responseCode == 1104 ||err.responseCode == 1105 ) {
          errorMessage=formatter(customMessages.getMessage(err.responseCode), err.maxUsage)
        }else if(err.responseCode == 893){
          errorMessage= formatter(customMessages.getMessage(err.responseCode), err.properties.minAllowedContractDates)
        }
        else{
          errorMessage= customMessages.getMessage(err.responseCode)
        }
        Modal.error({
          title: 'Hata',
          content: errorMessage

        });
          return;
      });
    }
    else{
      setModalConfirm(true);
    }

  }

  const confirmSale = () => {
    let valuesDiscount=formDiscount.getFieldsValue();
    let values= props.formRef.current.getFieldsValue();
    if (activeIndex=="2")
    {
      chargePackage(
        {
          packageId:selectedPackage.no,
          packageName:selectedPackage.name,
          couponCode:couponCode, 
          paymentMethod:'Faturaya Yansıt'
        }).then((result) => {
          history.push('/OrderSuccessful', selectedPackage);
        }).catch((err) => {
          Modal.error({
            title: 'Hata',
            content: customMessages.getMessage(err.responseCode)
          });
        });
    }
    if (activeIndex=="3")
    {
      createVirtualInvoices(
        {
          paketNO:selectedPackage.no,
          paketAdi:selectedPackage.name,
          couponCode:couponCode,
          paymentMethod:'Öde ve Kullan'
        }).then((result) => {
          history.push('/OrderSuccessful', selectedPackage);
        }).catch((err) => {
          Modal.error({
            title: 'Hata',
            content: customMessages.getMessage(err.responseCode)
          });
        });
    }
    if (activeIndex=="1")
    {
      getThreeDSessionId(
        {
          packageNo:selectedPackage.no,
          packageName:selectedPackage.name,
          couponCode:couponCode,
          paymentMethodId:values.paymentMethod===0? "": values.paymentMethod, 
          ccTokenId:ccToken, 
          paymentMethod:'Kredi Kartı'
        }).then((result) => {
          // history.push('/OrderSuccessful', {...selectedPackage});
       setCallBackUrl(config.paycellCallbackUrl +  "?pId=" + result.pId + (values.saveCC ? "&saveCardInfo=1" : "")  + "&apiUrl=" + config.uiURL);
          setThreeDSessionId(result.threeDSessionId);
          setTriggerClick(true);
        }).catch((err) => {
          Modal.error({
            title: 'Hata',
            content: customMessages.getMessage(err.responseCode)
          });
        });
    }

  }



  const onCheckCouponCode = () => 
  {
    formDiscount.validateFields().then(values => {
      checkCouponCode(values.couponCode).then((result) => {
        setDiscountList(result.discountList);
        setModalDiscount(false);
        setDiscount(1);
        setCouponCode(values.couponCode);
      }).catch((err) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(err.responseCode)
        });
      });
    }).catch(
      errorInfo => {
      });

  }

  useEffect(() => {
    if (!modalDiscount)
    {
      formDiscount.resetFields();
    }
  }, [modalDiscount]);


  useEffect(() => {
    setActiveIndex(props.tabIndex);
  }, [props.tabIndex]);

  return (
    <div className={classNames('box basket-summary', { 'bill-created' : props.billCreated },
                                                     { 'basket-summary--discount' : discount })}>
      {activeIndex == "3" && props.billCreated ? <InfoBox compClass=""
        content={<><h6 className='info-box__title'>Öde ve Kullan nedir?</h6>
          <p>“Öde ve Kullan
            yöntemi ile dilediğiniz Mesaj Üssü paketi için sanal bir fatura oluşturabilir ve bu faturayı herhangi Turkcell faturası öder gibi ödeyebilirsiniz. Ödeme bilgisi Turkcell’e ulaştığında satın almış olduğunuz Mesaj Üssü paketi hesabınıza yüklenecektir.</p></>
        }
      />
        :
        <>
          <div className='box__title'>{props.title}</div>
          <div className='basket-summary__items'>
        {selectedPackage?.name &&  <div>
              <span>“<strong>{selectedPackage?.name}</strong> Paket Ücreti:</span>
              <span>{selectedPackage.prize} TL</span>
            </div>}
          { discountList[selectedPackage?.no] ? <>
              <div className="discount">
                <span>Promosyonlu İndirimi: <button onClick={() => {setDiscountList([]);setDiscount(0);setCouponCode("");}}>Kaldır</button></span>
                <span>-{selectedPackage?.prize.toLocaleString('tr-TR') - discountList[selectedPackage?.no].toLocaleString('tr-TR')} TL</span>
              </div>
              <div className="total">
                <span>Toplam: </span>
                { discountList[selectedPackage?.no] ? <span className="total__price">{discountList[selectedPackage?.no].toLocaleString('tr-TR')} TL</span> : <span className="total__price">{selectedPackage.prize.toLocaleString('tr-TR')} TL</span> }
              </div>
            </>
            : false }
          </div>
        { discount ? false : <div className='basket-summary__row'>
          <a className="box__link" onClick={ () => setModalDiscount(true) }><Promo /> Promosyon Kodunuz Mu Var?</a>

        </div> }
          <Modal
            title="Promosyon Kodu Gir"
        visible={ modalDiscount }
        onCancel={ () => setModalDiscount(false) }
            footer={[
              <div className="modal-action">
                <Button
                  shape="round"
                  type="ghost"
              onClick={ () => setModalDiscount(false) }
                >
                  Vazgeç
                </Button>
                <Button
                  key="confirm"
                  type="primary"
              disabled={ !validDiscount }
                  htmlType="submit"
              onClick={(e)=> onCheckCouponCode()}
                >
                  Uygula
                </Button>
              </div>
            ]}>
            <p className="info-text text-center">MESAJ ÜSSÜ PROMOSYON KODUNUZ VARSA BU ALANA GİRİNİZ</p>
            <Form form={formDiscount}
              name="login"
              onValuesChange={onValuesChange}
            >
              <Form.Item
                name="couponCode"

                messageVariables={{ label: 'Promosyon Kodu' }}
                rules={[{ required: true }]}
              >
            <Input autoComplete="off" label="Promosyon Kodu"  maxLength="8" />
              </Form.Item>
            </Form>
          </Modal>
          <div className='basket-summary__contracts'>
        <AgreementModal agreement={props.agreement}  formRef={props.formRef} />

          </div>
          <div className='basket-summary__actions'>
            {activeIndex == "1" && props.visibility != true ?
              "" :
              <Button
                type="primary"
                htmlType="submit"
                shape="round"
                className="login-button"
                onClick={() => { openConfirm() }}
              >
                {activeIndex == "3" ? "Fatura Oluştur" : "Satın Al"}
              </Button>
            }
            {modalConfirm &&
            <ConfirmModal showModal={modalConfirm} loading={loadingCCToken} toggleModal={setModalConfirm}  onConfirmSale={confirmSale} selectedPackage={selectedPackage} purchaseType={activeIndex}/>
            }

          </div>
        </>
      }


    </div>
  )
}

export default BasketSummary